var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuickPollBg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1281 1274",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M995,0 C1152.95344,0 1281,128.046562 1281,286 C1281,443.953438 1152.95344,572 995,572 C837.046562,572 709,443.953438 709,286 C709,128.046562 837.046562,0 995,0 Z M995,154 C920.441559,154 860,213.769986 860,287.5 C860,361.230014 920.441559,421 995,421 C1069.55844,421 1130,361.230014 1130,287.5 C1130,213.769986 1069.55844,154 995,154 Z",
    id: "Combined-Shape",
    fill: "#CBF8FE",
    opacity: 0.19266183,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349,576 C541.747378,576 698,732.252622 698,925 C698,1117.74738 541.747378,1274 349,1274 C156.252622,1274 0,1117.74738 0,925 C0,732.252622 156.252622,576 349,576 Z M349,764 C257.873016,764 184,836.977586 184,927 C184,1017.02241 257.873016,1090 349,1090 C440.126984,1090 514,1017.02241 514,927 C514,836.977586 440.126984,764 349,764 Z",
    id: "Combined-Shape-Copy",
    fill: "#CBF8FE",
    opacity: 0.19266183,
    style: {
      mixBlendMode: "overlay"
    }
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFE8AC",
    x: 968,
    y: 635,
    width: 14,
    height: 14,
    rx: 7
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#C2EFF6",
    x: 1025,
    y: 553,
    width: 16,
    height: 16,
    rx: 8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickPollBg1);
export default __webpack_public_path__ + "static/media/quick-poll-bg1.190c0a396085b47f3a9575db4160870f.svg";
export { ForwardRef as ReactComponent };